import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext.js";
import { isLegacyGovernanceMode } from "../../lib/auth-mode.js";

/**
 * Tenant operator shell: `tenant_admin` JWT, or legacy API-key-only dev mode.
 * Sends `platform_admin` users to the platform console.
 */
export function RequireTenantApp() {
  const { user } = useAuth();
  const legacy = isLegacyGovernanceMode();
  const location = useLocation();

  if (user?.role === "platform_admin") {
    return <Navigate to="/admin" replace />;
  }

  if (
    user?.mfaEnrollmentRequired &&
    !location.pathname.startsWith("/settings")
  ) {
    return <Navigate to="/settings" replace />;
  }

  if (
    user?.role === "tenant_admin" ||
    user?.role === "tenant_operator" ||
    (legacy && !user)
  ) {
    return <Outlet />;
  }

  return <Navigate to="/login" replace />;
}
